<!-- @format -->

<div class="modal-header">
  <h2 class="modal-title">{{ "ENROLMENTS.SELECT_REALISATIONS" | translate }}</h2>
</div>
<div class="modal-body">
  <p>
    {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.CHOOSE_TEACHING_FOR_COURSE_UNIT" | translate }}
    <strong>{{ courseUnit.name | localizedString }} ({{ courseUnit.credits | creditRange }})</strong>.
  </p>
  @if (studies$ | async; as studies) {
    @for (item of studies; track item; let last = $last) {
      <div class="section-header">
        <h3 class="section-title">{{ item.assessmentItem.name | localizedString }} ({{ item.assessmentItem.credits | creditRange }})</h3>
        @if (item.aiAttainment; as attainment) {
          <span class="attainment-info">
            <sis-icon icon="achievement" color="success"></sis-icon
            >{{
              "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.ATTAINED_WITH_GRADE"
                | translate: { grade: attainment.gradeId | grade: attainment.gradeScaleId : "NAME" | async }
            }}
          </span>
        }
        @if (item.enrolmentLimit > 0) {
          <span class="enrolment-count-indicator">
            @if (item.enrolmentsRemaining > 0) {
              <strong>{{ item.enrolmentsRemaining }}/{{ item.enrolmentLimit }}</strong>
              {{ "ENROLMENT.OPEN_UNIVERSITY_ENROLMENT.ENROLMENTS_REMAINING" | translate }}
            }
            @if (item.enrolmentsRemaining === 0) {
              <strong>
                {{ "ENROLMENT.OPEN_UNIVERSITY_ENROLMENT.NO_ENROLMENTS_REMAINING" | translate }}
              </strong>
            }
          </span>
        }
      </div>
      @for (courseUnitRealisation of item.courseUnitRealisations; track courseUnitRealisation) {
        <app-course-unit-realisation-expandable
          [courseUnit]="courseUnit"
          [courseUnitRealisation]="courseUnitRealisation"
          [enrolmentLimitReached]="item.enrolmentsRemaining === 0"
          (enrolClicked)="onEnrolClick(courseUnitRealisation.id, item.assessmentItem.id)">
        </app-course-unit-realisation-expandable>
      }
      @if (!item.courseUnitRealisations?.length) {
        <p class="guidance">
          {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.NO_TEACHING_AVAILABLE" | translate }}
        </p>
      }
      @if (!last) {
        <hr />
      }
    }
  }
</div>
<div class="modal-footer">
  <sis-button (clicked)="close()" [hollow]="true">{{ "SIS_COMPONENTS.BUTTON.CANCEL" | translate }}</sis-button>
</div>
